<template>
  <div class="gallery">
    <v-container style="margin-top: 10px">
      <h3>Products</h3>
      <v-layout justify-center>
        <v-btn class="button" elevation="5" @click="newImage" rounded
          >Add a Product</v-btn
        >
      </v-layout>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span v-if="popup == 'edit'" class="headline">Edit Product</span>
              <span v-if="popup == 'add'" class="headline">Add Product</span>
            </v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" md="6" sm="6">
                  <v-text-field
                    label="Product Title"
                    v-model="gallery.name"
                    :error-messages="nameError"
                    required
                    @input="$v.gallery.name.$touch()"
                    @blur="$v.gallery.name.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-select
                    v-model="gallery.category"
                    :error-messages="categoryError"
                    required
                    @input="$v.gallery.category.$touch()"
                    @blur="$v.gallery.category.$touch()"
                    :items="[
                      'Pneutork Valves',
                      'Pneutork Limit Switch',
                      'Pneutork Actuators',
                      'MAATICS Push-in Fittings',
                      'MAATICS Technical Tubing and Hose',
                      'MAATICS Function Fittings',
                      'MAATICS Compression Fittings',
                      'MAATICS Quick Acting Couplers and Blowguns',
                      'MAATICS Threaded Accessories',
                      'MAATICS Industrial Ball Valves',
                      'MAATICS ISO Standard Cylinder',
                      'MAATICS Valves',
                      'MAATICS SS FITTINGS',
                      'MAATICS QRC',
                      'Norgren Valves',
                      'Norgren Push-in Fittings',
                      'Norgren Actuators',
                      'Norgren FRL',
                      'Norgren Hoses',
                      'Norgren Coils',
                      'Norgren Reed Switches',
                      'Parker Connectors',
                      'Parker Cylinders',
                      'Parker Hoses',
                      'Parker valves',
                      'Parker Transair',
                      'Parker Couplers',
                      'LEESPRING Springs',
                    ]"
                    label="Category"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field
                    label="Product Description"
                    v-model="gallery.description"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-file-input
                    chips
                    v-if="popup == 'add'"
                    counter
                    show-size
                    truncate-length="24"
                    v-model="images"
                    required
                    label="Select Image File..."
                    accept="image/*"
                    @change="uploadImage"
                  ></v-file-input>
                  <div class="img">
                    <span v-if="popup == 'edit'">
                      <img class="demo" :src="gallery.images" alt="" /> <br />
                    </span>
                    <span v-if="popup == 'add'">
                      <img class="demo" :src="imgurl" alt="" />
                    </span>
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-file-input
                    chips
                    v-if="popup == 'add'"
                    counter
                    show-size
                    v-model="brochure"
                    required
                    label="Select Brochure File..."
                    accept="application/pdf"
                    @change="uploadBrochure"
                  ></v-file-input>
                  <div class="img">
                    <span v-if="popup == 'edit'">
                      <iframe :src="gallery.brochure" width="300" height="300">
                        ></iframe
                      >
                    </span>
                    <span v-if="popup == 'add'">
                      <iframe :src="gallery.brochure" width="550" height="300">
                        ></iframe
                      >
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">
                Close
              </v-btn>
              <v-btn
                v-if="popup == 'edit'"
                color="blue darken-1"
                text
                @click.prevent="updateGallery"
              >
                Update
              </v-btn>
              <v-btn
                color="blue darken-1"
                v-if="popup == 'add'"
                text
                @click.prevent="addImage"
              >
                Add
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-simple-table style="margin-top: 4%">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Image</th>
              <th class="text-left">Category</th>
              <th class="text-left">Edit</th>
              <th class="text-left">Delete</th>
            </tr>
          </thead>
          <tbody :key="index" v-for="(gallery, index) in Products">
            <tr>
              <td>{{ gallery.name }}</td>
              <td>
                <v-avatar>
                  <img width="300px" :src="gallery.images" alt="John" />
                </v-avatar>
              </td>
              <td>{{ gallery.category }}</td>
              <td>
                <v-btn icon @click="editGallery(index)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn icon @click="deleteGallery(gallery)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>

    <v-snackbar top v-model="snackbar">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
//eslint-disable-next-line
import { fb, db } from "../firebase.js";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "Gallery",
  mixins: [validationMixin],
  validations: {
    gallery: {
      name: { required },
      category: { required },
    },
  },
  data() {
    return {
      snackbar: false,
      text: "",
      popup: "",
      dialog: false,
      imgurl: null,
      images: null,
      brochure: null,
      Products: [],
      gallery: {
        name: null,
        description: null,
        category: null,
        images: null,
        brochure: null,
      },
    };
  },
  firestore() {
    return {
      Products: db.collection("Products"),
    };
  },
  methods: {
    newImage() {
      this.reset();
      this.popup = "add";
      this.dialog = !this.dialog;
    },
    reset() {
      this.gallery.name = null;
      this.gallery.description = null;
      this.gallery.images = null;
      this.gallery.brochure = null;
      this.gallery.category = null;
      this.images = null;
      this.brochure = null;
      this.imgurl = null;
      this.brochureurl = null;
    },
    addImage() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        console.log(this.images.name);
        if (this.images != null) {
          var random = Math.random().toString(36).substring(2, 15);
          var storageRef = fb
            .storage()
            .ref("Products/" + (random + this.images.name));
          let uploadTask = storageRef.put(this.images);
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              console.log(snapshot);
            },
            (error) => {
              console.log(error);
              // Handle unsuccessful uploads
            },
            () => {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                this.gallery.images = downloadURL;
                console.log("File available at", downloadURL);
                // db.collection("Products")
                //   .add(this.gallery)
                //   .catch(function (error) {
                //     console.error("Error adding document: ", error);
                //   });
                if (this.brochure != null) {
                  var storageRefbroch = fb
                    .storage()
                    .ref("Products/" + this.brochure.name);
                  let uploadTaskbroch = storageRefbroch.put(this.brochure);
                  uploadTaskbroch.on(
                    "state_changed",
                    (snapshot) => {
                      console.log(snapshot);
                    },
                    (error) => {
                      console.log(error);
                    },
                    () => {
                      uploadTaskbroch.snapshot.ref
                        .getDownloadURL()
                        .then((downloadURL) => {
                          this.gallery.brochure = downloadURL;
                          console.log("File available at", downloadURL);
                          db.collection("Products")
                            .add(this.gallery)
                            .catch(function (error) {
                              console.error("Error adding document: ", error);
                            });
                        });
                    }
                  );
                } else {
                  db.collection("Products")
                    .add(this.gallery)
                    .catch(function (error) {
                      console.error("Error adding document: ", error);
                    });
                }
              });
            }
          );

          //logic
          this.dialog = false;
          this.text = "Product added";
          this.snackbar = true;
        } else {
          alert("Add Image");
        }
      } else {
        console.log("not");
      }
    },
    editGallery(i) {
      this.popup = "edit";
      this.gallery = this.Products[i];
      this.dialog = !this.dialog;
    },
    updateGallery() {
      // this.$firestore.Products.doc(this.gallery[".key"]).update(this.gallery);
      let id = this.gallery[".key"];
      // console.log(id)
      db.collection("Products")
        .doc(id)
        .update({
          name: this.gallery.name,
          description: this.gallery.description,
          category: this.gallery.category,
        })
        .then(() => {
          this.dialog = !this.dialog;
          this.text = "Product updated";
          this.snackbar = true;
        });
    },
    deleteGallery(doc) {
      let image = fb.storage().refFromURL(doc.images);
      // console.log(brochure)
      console.log(image);
      image
        .delete()
        .then(function () {
          console.log("image deleted");
        })
        .catch(function (error) {
          // Uh-oh, an error occurred!err
          console.log(error);
          console.log("an error occurred");
        });

      this.$firestore.Products.doc(doc[".key"])
        .delete()
        .then(() => {
          console.log("Document successfully deleted!");
          this.text = "Product successfully deleted!";
          this.snackbar = true;
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
          this.text = "Error Removing product";
          this.snackbar = true;
        });
        let brochure = fb.storage().refFromURL(doc.brochure);
        brochure
        .delete()
        .then(function () {
          console.log("broucher deleted");
        })
        .catch(function (error) {
          // Uh-oh, an error occurred!err
          console.log(error);
          console.log("an error occurred");
        });
      // console.log(doc['.key'])
    },
    uploadImage() {
      // let file = e.target.files[0];
      if (this.images === null) {
        this.imgurl = null;
      }
      this.imgurl = URL.createObjectURL(this.images);
      console.log(this.imgurl);
    },
    uploadBrochure() {
      // let file = e.target.files[0];
      if (this.brochure === null) {
        this.brochureurl = null;
      }
      this.brochureurl = URL.createObjectURL(this.brochure);
      console.log(this.brochureurl);
    },
  },
  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.gallery.name.$dirty) return errors;
      !this.$v.gallery.name.required && errors.push("title is required.");
      return errors;
    },
    // descriptionError() {
    //   const errors = [];
    //   if (!this.$v.gallery.description.$dirty) return errors;
    //   !this.$v.gallery.description.required && errors.push("description is required.");
    //   return errors;
    // },
    categoryError() {
      const errors = [];
      if (!this.$v.gallery.category.$dirty) return errors;
      !this.$v.gallery.category.required &&
        errors.push("category is required.");
      return errors;
    },
  },
  watch: {
    // customer: {
    //   //eslint-disable-next-line
    //   handler(val, oldVal) {
    //     if (this.images === null) {
    //       console.log("dsa nul")
    //       // this.imgurl = "";
    //       // this.customer.images = "";
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>

<style>
span.delete-img {
  position: absolute;
}

i {
  color: #040674;
}

span.delete-img:hover {
  cursor: pointer;
  color: #f5a623;
}

.demo {
  width: auto;
  height: 200px;
}

@media only screen and (max-width: 450px) {
  .demo {
    height: 100px;
  }
}
</style>
